import service from "./service"
//import mock from "./mock"

const saveApplicantProgress = async (data) => {
    return service(data)
    //return mock()
}

export default saveApplicantProgress
